import { normalizarNombreDocente } from "./docenteNombre";

const STORAGE_KEY = "catalogo-docentes-postgrados";
const ROLES_DOCENTE = ["director", "tutor", "cotutor", "evaluador", "evaluador1", "evaluador2"];

const normalizarDocente = (nombre) => normalizarNombreDocente(nombre);

export const obtenerDocentesDeRegistro = (registro) =>
  ROLES_DOCENTE
    .map((rol) => normalizarDocente(registro?.[rol]))
    .filter(Boolean);

export const combinarDocentes = (...listas) => {
  const docentes = new Set();

  listas.flat().forEach((nombre) => {
    const docente = normalizarDocente(nombre);

    if (docente) {
      docentes.add(docente);
    }
  });

  return Array.from(docentes).sort((a, b) => a.localeCompare(b, "es"));
};

export const cargarCatalogoDocentes = () => {
  const almacenado = window.localStorage.getItem(STORAGE_KEY);

  if (!almacenado) {
    return [];
  }

  try {
    return combinarDocentes(JSON.parse(almacenado));
  } catch {
    return [];
  }
};

export const guardarCatalogoDocentes = (docentes) => {
  const catalogo = combinarDocentes(docentes);
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(catalogo));
  return catalogo;
};
